import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { ThemeProvider } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
import theme from "./theme";

import Login from "./pages/Login";
import MainPage from "./pages/Main";
import ProtectedRoute from "./components/ProtectedRoute";
import ErrorBoundary from "./components/ErrorBoundary";

function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      {/* One crash in any screen below shows a recoverable message instead of
          blanking the whole app. */}
      <ErrorBoundary>
      <BrowserRouter>
        <Routes>

        {/* LOGIN */}
        <Route path="/" element={<Login />} />
        <Route path="/login" element={<Login />} />  {/* ✅ Add this */}

        {/* Employee Panel is now a module inside the main shell; keep the old
            /admin URL working by redirecting it there. */}
        <Route path="/admin" element={<Navigate to="/main" replace />} />

        {/* MAIN APP — any logged-in user; the sidebar + backend gate per
            user based on the effective module list, not the role. */}
        <Route
          path="/main"
          element={
            <ProtectedRoute>
              <MainPage />
            </ProtectedRoute>
          }
        />

        </Routes>
      </BrowserRouter>
      </ErrorBoundary>
    </ThemeProvider>
  );
}

export default App;